import { VAT_ACTION_TYPE, VatActions } from './vat-type';
import { RootState } from '../../../../redux/root-reducer';

export enum VAT_STATE_KEY {
  LIST = 'list',
  ALERT_STATE = 'alert_state',
  PREFILL = 'prefill',
}

export enum VAT_ALERT {
  ALERT_BLANK = 'alert_blank',
  ALERT_DELETE_SUCCESS = 'alert_delete_success',
  ALERT_DELETE_FAIL = 'alert_delete_fail',
  ALERT_TAXES_SUCCESS = 'alert_taxes_success',
  ALERT_TAXES_FAIL = 'alert_taxes_fail',
}

export type VatState = {
  [VAT_STATE_KEY.LIST]?: object,
  [VAT_STATE_KEY.ALERT_STATE]: VAT_ALERT,
  [VAT_STATE_KEY.PREFILL]: undefined | object,
};

const initialState: VatState = {
  [VAT_STATE_KEY.LIST]: [],
  [VAT_STATE_KEY.ALERT_STATE]: VAT_ALERT.ALERT_BLANK,
  [VAT_STATE_KEY.PREFILL]: undefined,
};

export const vatReducers = (state = initialState, action: VatActions) => {
  switch (action.type) { // NOSONAR [typescript:S1301] followed usage pattern of reducer
    case VAT_ACTION_TYPE.SET_VAT_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
};

export const vatStateSelector = (key: VAT_STATE_KEY) => (state: RootState) => state.vat[key];
